import { api } from "../../../utils/api";

export const loginUserApi = async ({ email, password }) => {
  const res = await api.post("/login", { email, password });

  if (res.data?.status !== true) {
    throw new Error(res.data?.message || "Invalid credentials");
  }

  return res.data;
};